/**
 * GenericPageSkeleton - Fast loading skeleton for generic pages
 * Used for pages that don't have specific skeletons yet
 */

import { Skeleton } from '../ui/skeleton';
import { Card } from '../ui/card';
import { Container, Stack } from './';

export function GenericPageSkeleton() {
  return (
    <Container size="large" className="py-6 md:py-8">
      <Stack spacing="large">
        {/* Header Skeleton */}
        <div className="space-y-3">
          <Skeleton className="h-8 w-48" />
          <Skeleton className="h-4 w-64" />
        </div>

        {/* Main Content Card */}
        <Card className="p-6">
          <div className="space-y-4">
            <Skeleton className="h-6 w-40" />
            <div className="space-y-3">
              {[1, 2, 3, 4, 5].map((i) => (
                <div key={i} className="flex items-start gap-4">
                  <Skeleton className="h-4 w-32" />
                  <Skeleton className="h-4 flex-1" />
                </div>
              ))}
            </div>
          </div>
        </Card>

        {/* Secondary Card */}
        <Card className="p-6">
          <div className="space-y-4">
            <Skeleton className="h-6 w-40" />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="space-y-2">
                  <Skeleton className="h-4 w-24" />
                  <Skeleton className="h-10 w-full" />
                </div>
              ))}
            </div>
          </div>
        </Card>
      </Stack>
    </Container>
  );
}
